import { useElementBreakpoint } from 'hooks/useElementBreakpoint';
import ThreeByOneHScrollWidget, {
  THREE_BY_ONE_HSCROLL_DEFAULT_BREAKPOINT_MAX,
} from '../ThreeByOneHScrollWidget';
import NewsweekPlayerControls from './NewsweekPlayerControls';

const NewsweekWidget: React.FC = () => {
  const { matches: isMobile, ref: mobileRef } = useElementBreakpoint({
    max: THREE_BY_ONE_HSCROLL_DEFAULT_BREAKPOINT_MAX,
  });

  return (
    <ThreeByOneHScrollWidget
      artworkAspectRatio={1}
      controls={<NewsweekPlayerControls />}
      unitSpacing={isMobile ? 8 : 12}
      ref={mobileRef}
    />
  );
};

export default NewsweekWidget;
